<script>
/**
 * Footer component
 */
export default {
  name: 'Footer'
}
</script>

<template>
  <div>
    <!--START FOOTER-->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 margin-t-20">
            <h4>Somos DIU</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a href="#features">Nuestra Empresa</a>
                </li>
                <li>
                  <a href="#cliets">Nuestros productos</a>
                </li>
                <li>
                  <a href="#getstarted">Nuestra red de Franquicias</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Nuestra Franquicia</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a href="#services">Ventajas de la Franquicia DIU</a>
                </li>
                <li>
                  <a href="#pricing">Perfil requerido</a>
                </li>
                <li>
                  <a href="#testimonial">Inversión inicial</a>
                </li>
                
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Más sobre nosotros</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a href="#contact">Contáctanos</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4></h4>
            <div class="text-muted margin-t-20">
              <p></p>
            </div>
            <form class="form subscribe">
              <input placeholder="Email" class="form-control" required />
              <a href="#" class="submit">
                <i class="pe-7s-paper-plane"></i>
              </a>
            </form>
          </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p
                class="copy-rights text-muted mb-3 mb-sm-0"
              >2019 - {{ new Date().getFullYear()}} © DIU Emilio Benzo S.A. - Todos los derechos reservados</p>
            </div>
            <div class="float-right pull-none">
              <ul class="list-inline social m-0">
                <li class="list-inline-item">
                  <a href=https://www.instagram.com/drogueriaindustrialuruguaya/ class="social-icon">
                    <i class="mdi mdi-instagram"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href=https://www.facebook.com/DrogIndUruguaya class="social-icon">
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-google-plus"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href=http://www.diu.com.uy/ class="social-icon">
                    <i class="mdi mdi-web"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>